/* eslint-disable */
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { compose } from 'redux';
import formatWithTime from '../../Support/DateTime/FormatWithTime/DateTimeFormatWithTime.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import KeyValueDateTimeFieldPropTypes from './KeyValueDateTimeField.component.props';
import keyValueDateTimeFieldStyles from './KeyValueDateTimeField.component.styles';

/**
 * KeyValueDateTimeFieldComponent
 * @export
 * @class KeyValueDateTimeFieldComponent
 * @extends {React.Component<KeyValueDateTimeFieldComponentComposedProps, KeyValueDateTimeFieldComponentState>}
 */
export class KeyValueDateTimeFieldComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<KeyValueDateTimeFieldComponentProps>}
   * @memberof KeyValueDateTimeFieldComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`KeyValueDateTimeField`}
   * @memberof KeyValueDateTimeFieldComponent
   */
  static displayName = `KeyValueDateTimeField`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof KeyValueDateTimeFieldComponent
   */
  static propTypes = KeyValueDateTimeFieldPropTypes;

  /**
   * Render the component
   * @returns {React.Component} The rendered `<KeyValueDateTimeFieldComponent />`
   * @memberof KeyValueDateTimeFieldComponent
   */
  render() {
    const { InputProps, formatString, GridItemProps, label, value } = this.props;
    const {
      classes: { root: inputRoot },
    } = InputProps;
    const transformedValue = formatWithTime(value, formatString);
    return (
      <Grid item key={label} lg md sm xl xs={12} {...GridItemProps}>
        <I18n variant="caption">{label}</I18n>
        <div className={inputRoot}>
          <Typography>{transformedValue}</Typography>
        </div>
      </Grid>
    );
  }
}

/** @type {React.ComponentClass<KeyValueDateTimeFieldComponentProps>} */
const KeyValueDateTimeField = compose(withStyles(themeCreateInjectableStyles(keyValueDateTimeFieldStyles), { withTheme: true }))(
  KeyValueDateTimeFieldComponent,
);

export default KeyValueDateTimeField;
